// Working days for Call for Quote dates, the same rules as the backend
// (FM-BackEnd-v2 src/modules/cfq/working-days.ts): Monday to Friday, skipping public holidays.
// Dates are 'YYYY-MM-DD' strings so no time zone can move a date by a day.

const toDate = (iso) => new Date(`${iso}T00:00:00Z`);

export const shiftDays = (iso, days) => {
  const date = toDate(iso);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

export const isWorkingDay = (iso, holidays) => {
  const weekday = toDate(iso).getUTCDay();
  return weekday !== 0 && weekday !== 6 && !holidays.has(iso);
};

/** The date `count` working days after `from` (`from` itself is not counted). */
export const addWorkingDays = (from, count, holidays) => {
  let date = from;
  for (let left = count; left > 0; ) {
    date = shiftDays(date, 1);
    if (isWorkingDay(date, holidays)) left -= 1;
  }
  return date;
};

/** Working days after `from`, up to and including `to`. */
export const workingDaysBetween = (from, to, holidays) => {
  let count = 0;
  for (let date = shiftDays(from, 1); date <= to; date = shiftDays(date, 1)) {
    if (isWorkingDay(date, holidays)) count += 1;
  }
  return count;
};

/** "15.12.2026", the format the CfQ register has always used. */
export const formatDate = (iso) => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}` : '');

/** "Tue 15 Dec 2026". */
export const formatLong = (iso) =>
  iso ? toDate(iso).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }) : '';

export const weekdayShort = (iso) => toDate(iso).toLocaleDateString('en-GB', { weekday: 'short', timeZone: 'UTC' });
